import { getProperty } from "@/util/object"

export const findIndex = function(items, item, predicate) {
    if (!items || !items.length || !item) {
        return -1
    }

    if (!predicate) {
        predicate = candidate => candidate === item
    }

    if (typeof predicate === "string") {
        const prop = predicate
        predicate = candidate => candidate && getProperty(candidate, prop) === getProperty(item, prop)
    }

    return items.findIndex(predicate)
}

export const indexBy = (items, property) => {
    let map = {}

    if (typeof property === "string") {
        const prop = property
        property = candidate => getProperty(candidate, prop)
    }

    ;(items || []).forEach(item => {
        map[property(item)] = item
    })

    return map
}

export const sortBy = (items, selector, mapper = value => value) => {
    if (!items) {
        return []
    }

    if (items.length < 2) {
        return items
    }

    const comparator = selectorToComparator(selector, mapper)
    const sortedItems = [...items]
    sortedItems.sort(comparator)

    return sortedItems
}

export const groupBy = (items, property) => {
    let map = {}

    if (typeof property === "string") {
        const prop = property
        property = candidate => getProperty(candidate, prop)
    }

    ;(items || []).forEach(item => {
        let key = property(item)
        let group = map[key] || []

        group.push(item)

        map[key] = group
    })

    return map
}

export default {
    findIndex,
    groupBy,
    indexBy,
    sortBy,
}

function selectorToComparator(selector, mapper) {
    if (Array.isArray(selector)) {
        return arrayToComparator(selector, mapper)
    }

    if (typeof selector === "string") {
        return stringSelectorToComparator(selector, mapper)
    }

    if (typeof selector === "function") {
        return functionSelectorToComparator(selector, mapper)
    }

    return identitySelectorToComparator(mapper)
}

function identitySelectorToComparator(mapper) {
    return (a, b) => {
        const v1 = mapper(a)
        const v2 = mapper(b)
        return v1 === v2 ? 0 : v1 > v2 ? 1 : -1
    }
}

function functionSelectorToComparator(fn, mapper) {
    return (a, b) => {
        const v1 = mapper(fn(a))
        const v2 = mapper(fn(b))
        return v1 === v2 ? 0 : v1 > v2 ? 1 : -1
    }
}

function stringSelectorToComparator(string, mapper) {
    let sort = 1

    if (string[0] === "-") {
        sort = -1
        string = string.substring(1)
    }

    const colonIndex = string.indexOf(":")
    let flags = ""

    if (colonIndex >= 0) {
        string = string.substring(0, colonIndex)
        flags = flags.substring(colonIndex)
    }

    const ignoreCase = flags.includes("i")

    return (a, b) => {
        let v1 = mapper(getProperty(a, string))
        let v2 = mapper(getProperty(b, string))

        if (ignoreCase) {
            if (typeof v1 === "string") v1 = v1.toLowerCase()
            if (typeof v2 === "string") v2 = v2.toLowerCase()
        }

        const cmp = v1 === v2 ? 0 : v1 > v2 ? 1 : -1
        return sort * cmp
    }
}

function arrayToComparator(array, mapper) {
    const comparators = array.map(selector => selectorToComparator(selector, mapper))

    return (a, b) => {
        for (const comparator of comparators) {
            const cmp = comparator(a, b)

            if (cmp) {
                return cmp
            }
        }

        return 0
    }
}
